import { useState } from 'react'

interface LogEntry {
  type: 'request' | 'response' | 'info'
  direction?: string
  mti?: string
  fields: { label: string; value: string }[]
  raw: string
}

function parseHostLog(raw: string): LogEntry[] {
  const lines = raw.split('\n').filter((l) => l.trim())
  return lines.map((line) => ({
    type: 'info',
    raw: line.trim(),
    fields: [{ label: 'Line', value: line.trim() }],
  }))
}

export default function HostLog() {
  const [input, setInput] = useState('')
  const [entries, setEntries] = useState<LogEntry[] | null>(null)
  const [error, setError] = useState('')

  const handleParse = () => {
    setError('')
    setEntries(null)
    if (!input.trim()) {
      setError('Please paste your host log content.')
      return
    }
    try {
      const result = parseHostLog(input)
      setEntries(result)
    } catch {
      setError('Failed to parse host log.')
    }
  }

  return (
    <div className="min-h-screen p-2">
      <h2 className="mb-6 text-left text-2xl font-bold text-gray-900">Host Log Viewer</h2>

      <div className="space-y-3">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Paste your EMV L3 host log here..."
          className="h-40 w-full rounded-xl border border-gray-300 bg-white p-4 font-mono text-sm text-gray-900 outline-none focus:ring-2 focus:ring-indigo-500"
        />

        <button
          onClick={handleParse}
          className="cursor-pointer rounded-xl bg-indigo-600 px-6 py-2 font-semibold text-white shadow transition hover:bg-indigo-700"
        >
          View Log
        </button>

        {error && <div className="font-medium text-red-600">{error}</div>}

        {entries && entries.length > 0 && (
          <div className="mt-2 space-y-2">
            {entries.map((entry, i) => (
              <div
                key={i}
                className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-2 font-mono text-sm text-gray-800"
              >
                {entry.raw}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
